import { MutationKey } from '@shared/config';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import type { ChatOutgoingPayload } from '@packages/chat/react';
import { candidatesApi } from '../candidatesApi';
import { candidateQueryKeys } from '../queryKeys';

export const usePostCandidateMessage = (id: string) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationKey: [MutationKey.UPDATE_CANDIDATE, id],
    mutationFn: (payload: ChatOutgoingPayload) =>
      candidatesApi.sendMessage(id, payload.data, payload.type),
    // The chat shows the sent message locally until a refresh returns it.
    onSettled: () => {
      void queryClient.invalidateQueries({
        queryKey: candidateQueryKeys.processesRefreshRoot(id),
      });
      void queryClient.invalidateQueries({
        queryKey: candidateQueryKeys.processesRoot(id),
      });
    },
  });
};
